/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('offersPanel', {
    templateUrl: 'app/components/offers/panel/Panel.html',
    controller: OffersPanel,
    bindings: {
      onClick: '&',
      roomGroupCategoryFilterId: '<',
      categoryId: '<',
      checkIn: '<',
      checkOut: '<',
      occupancy: '<'
    }
  });

function OffersPanel(PanelObserver, Params, ConfigBookingEngine, $state) {
  var $this = this;
  $this.PanelObserver = PanelObserver;
  $this.Params = Params;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.$state = $state;
}

OffersPanel.prototype = {
  isEnabledCategoryFilter: function () {
    return this.ConfigBookingEngine.showCategoriesFilter();
  },

  isEnabledHostelView: function () {
    return this.ConfigBookingEngine.isHostelViewEnabled();
  },

  handleClick: function () {
    this.onClick();
  },

  reload: function () {
    var roomGroupCategoryFilterId = this.PanelObserver.getRoomGroupCategoryFilterId();
    var categoryId = this.PanelObserver.getCategoryId();
    var checkIn = this.PanelObserver.getCheckIn();
    var checkOut = this.PanelObserver.getCheckOut();
    var occupancy = this.PanelObserver.getOccupancy();
    var discountCode = this.Params.getDiscountCode();

    this.$state.go('booking.offers', {
      roomGroupCategoryFilterId: roomGroupCategoryFilterId,
      categoryId: categoryId,
      checkIn: moment(checkIn).format('YYYY-MM-DD'),
      checkOut: moment(checkOut).format('YYYY-MM-DD'),
      occupancy: encodeURIComponent(angular.toJson(occupancy)),
      discountCode: discountCode
    }, {reload: 'booking.offers'});
  }
};
